module.exports = __webpack_public_path__ + "img/car_group.dce65c28.jpg";